import { mapActions, mapGetters, mapMutations } from "vuex";

import ProfileNavigation from "./components/navigation/index.vue";
import MobileProfileNavigation from "./components/mobile-navigation/index.vue";

export default {
    name: "profile",
    data() {
        return {
            showNavigation: false,
        };
    },
    components: {
        ProfileNavigation,
        MobileProfileNavigation,
    },
    created() {
        if (this.$route.name === "profile-user") {
            this.changeShowPersonalMenu(true);
        } else {
            this.changeShowPersonalMenu(false);
        }
    },
    computed: {
        ...mapGetters({
            user: "user/user",
            showMobileMenu: "user/showMobileMenu",
            prevRoute: "user/prevRoute",
            profileRoutes: "user/profileRoutes",
        }),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({
            changeShowPersonalMenu: "user/MOBILE_CHANGE_SHOW_MENU",
            getPrevRoute: "user/SET_PREV_ROUTE",
            setProfileRoutes: "user/SET_PROFILE_ROUTES",
        }),
        changeNavigation(val) {
            this.showNavigation = val;
        },
    },
    destroyed() {
        this.showNavigation = false;
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.getPrevRoute(from.path);
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.setProfileRoutes(from.path);
        next();
    },
    // beforeRouteLeave(to, from, next) {
    //     next((vm) => {
    //         vm.getPrevRoute(from.path);
    //     });
    // },
};
